export default class OperatingModeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
  }
}